export type ThemeName = 'dark' | 'light'

const STORAGE_KEY = 'wyens_theme'

class ThemeController {
    private _theme: ThemeName

    constructor(){
        this._theme = this.readStored() || 'dark'
        this.applyTheme(this._theme)
    }

    private readStored(): ThemeName | null {
        try {
            const stored = window.localStorage.getItem(STORAGE_KEY)
            return stored === 'light' || stored === 'dark' ? stored : null
        } catch(e) {
            return null
        }
    }

    private applyTheme(theme: ThemeName){
        document.documentElement.setAttribute('data-theme', theme)
    }

    get theme(): ThemeName {
        return this._theme
    }

    setTheme = (theme: ThemeName) => {
        if(this._theme === theme) return
        this._theme = theme
        this.applyTheme(theme)
        try {
            window.localStorage.setItem(STORAGE_KEY, theme)
        } catch(e) {}
    }
}

export { ThemeController }
